import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { getTermsText } from '../../utils/commonUtils';
import { useSweep } from '../../hooks/useSweep';

const Terms = ({ showTermsText, TermsLink, margin }) => {
    const { sweep } = useSweep();
    const termsText = showTermsText && getTermsText(sweep.closeDate);
    const extraText =
        showTermsText && ' Opening and closing times may be subject to change.';

    return (
        <Styled.Terms margin={margin}>
            {termsText}
            <TermsLink>
                <Styled.TermsLink>
                    18+ and UK only, T&Cs apply, see here.
                </Styled.TermsLink>
            </TermsLink>
            {extraText}
        </Styled.Terms>
    );
};

Terms.defaultProps = {
    margin: '0  0 20px 0',
    showTermsText: true
};

Terms.propTypes = {
    showTermsText: PropTypes.bool,
    TermsLink: PropTypes.func.isRequired,
    margin: PropTypes.string
};

export default Terms;
